import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Popover,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Commonmodal from "./commonModal";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../ReduxStore/userReducer";
import { useNavigate } from "react-router-dom";
import { fetchGetCRMData } from "../ReduxStore/reduxThunk";
import { CRMData, CRMPostData, resetCrmData } from "../ReduxStore/actions";
import { GetData } from "../API/getApi";
import { postCrmData } from "../API/API";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CustomCheckbox } from "../sharedFiles/customCheckbox/customCheckBox";
import { PostData } from "../API/postApi";
import { toast, ToastContainer } from "react-toastify";
import SunspotLoader from "../sharedFiles/loader/loader";
import { GetSalesPerson } from "../API/Greeter/GreeterThunk";

const Greeter = ({ formData, setFormData,GetSalesPersonData }) => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const userdata = useSelector(selectUser);
  const databaseName = userdata?.DatabaseName;
  const jwtToken = userdata?.JwtToken;
  const [CrmFullData, setCrmFullData] = useState([]);
  // const [ItemMaster, setItemMaster] = useState();
  const [modalValue, setModalValue] = useState();
  const [modalName, setModalName] = useState();
 
  const [salesPerson, setSalesPerson] = useState(GetSalesPersonData&&GetSalesPersonData);
  const [DueDate, setDueDate] = React.useState(dayjs());
  // const Item = useSelector((state) => state.item.items);
  const [modalType, setModalType] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAddress, setShowAddress] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const SiteValues = ["Yes", "No"];
  const [isLoading, setIsLoading] = useState(false);
  const fieldOrder = [
    "WalkINID",
    "WalkInType",
    "PhoneNo",
    "Reference",
    "LeadLevel",
    "AssignExecutive",
    "customerCategory",
    "Segment",
    "CustomerProfile",
    "SiteType",
    "CurrentWorkStatus",
    "ExpectedComplationOfWork",
    "ItemsChecked",
    "EstimatedValue",
    "RequrimentType",
    "SiteVist",
    "Address",
  ];
  const modalFields = [
    "WalkInType",
    "AssignExecutive",
    "customerCategory",
    "Segment",
    "CustomerProfile",
    "SiteType",
    "CurrentWorkStatus",
    "ItemsChecked",
    "RequrimentType",
  ];

  const fetchCrmData = async () => {
    if (userdata || userdata?.databaseName) {
      try {
        // Fetch CRM data
        const crmResponse = await fetchGetCRMData(databaseName, jwtToken, dispatch, navigate);
        setCrmFullData(crmResponse); 
      } catch (crmError) {
        // console.log("CRM Data Fetch Error:", crmError);
      }
      // dispatch(GetSalesPerson({ databaseName }))
      // // try {
      // //   // Fetch Sales Person data
      // //   const response = await GetData(
      // //     `${GetSalesPerson}databaseName=${databaseName}`,
      // //     {
      // //       headers: {
      // //         wg_token: jwtToken,
      // //       },
      // //     },
      // //     dispatch,
      // //     navigate
      // //   );
      // //   const slpNames = response.map((item) => ({ slpName: item.slpName }));
      // //   setSalesPerson(slpNames);
      // } catch (salesError) {
      //   // console.log("Sales Person Data Fetch Error:", salesError);
      // }
    }
  };
  useEffect(() => {
    fetchCrmData();
  }, [dispatch]);

  const {
    item1: customerCate,
    item2: u_Segment,
    item3: u_CustomPro,
    item4: u_SiteType,
    item5: u_WalkType,
    item6: u_ReqType,
    item7: u_CurrentWS,
  } = CrmFullData;

  const handleModalOpen = (e) => {
    const { name } = e.target;
    openModalForField(name);
  };

  useEffect(() => {
    if (formData.SiteVist === "Yes") {
      setShowAddress(true);
    } else {
      setShowAddress(false);
    }
  }, [formData.SiteVist]);

  const handleSiteChange = (e) => {
    const { value } = e.target;
    const updatedFormData = {
      ...formData,
      SiteVist: value,
    };
    if (value === "Yes") {
      setShowAddress(true);
    }
    if (value === "No") {
      setShowAddress(false);
    }
    setFormData(updatedFormData);
    dispatch(CRMPostData(updatedFormData));
  };
  const handleSegmentChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => {
      const updatedItems = checked
        ? [...(prevData.Segment || []), { u_Segment: name }]
        : (prevData.Segment || []).filter((item) => item.u_Segment !== name);

      const updatedFormData = { ...prevData, Segment: updatedItems };
      dispatch(CRMPostData(updatedFormData)); // Dispatch the updated formData immediately
      return updatedFormData;
    });
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => {
        const updatedItems = checked
          ? [
              ...(prevData.ItemsChecked || []),
              { itemCode: name, itemName: value },
            ]
          : (prevData.ItemsChecked || []).filter(
              (item) => item.itemCode !== name
            );

        const updatedFormData = { ...prevData, ItemsChecked: updatedItems };
        dispatch(CRMPostData(updatedFormData)); // Dispatch the updated formData immediately
        return updatedFormData;
      });
    } else {
      const updatedFormData = {
        ...formData,
        [name]: value,
      };
      setFormData(updatedFormData);
      dispatch(CRMPostData(updatedFormData)); // Dispatch the updated formData immediately
      setOpen(false);
      if (
        !(
          name === "PhoneNo" ||
          name === "Reference" ||
          name === "EstimatedValue"
        )
      ) {
        openNextModal(name);
      }
    }
  };

  const openModalForField = (fieldName) => {
    switch (fieldName) {
      case "AssignExecutive":
        setModalValue(salesPerson);
        break;
      case "customerCategory":
        setModalValue(customerCate);
        break;
      case "Segment":
        setModalValue(u_Segment);
        break;
      case "CustomerProfile":
        setModalValue(u_CustomPro);
        break;
      case "SiteType":
        setModalValue(u_SiteType);
        break;
      case "WalkInType":
        setModalValue(u_WalkType);
        break;
      case "RequrimentType":
        setModalValue(u_ReqType);
        break;
      case "CurrentWorkStatus":
        setModalValue(u_CurrentWS);
        break;
      default:
        setModalValue(null);
    }
    setModalName(fieldName);
    setOpen(true);
  };
  const openNextModal = (currentName) => {
    const currentIndex = fieldOrder.indexOf(currentName);
    const nextField = fieldOrder[currentIndex + 1];

    if (nextField) {
      if (modalFields.includes(nextField)) {
        openModalForField(nextField);
      } else {
        const inputField = document.querySelector(`input[name="${nextField}"]`);
        if (inputField) {
          inputField.focus();
        }
      }
    }
  };

  const openPreviousModal = (currentName) => {
    const currentIndex = fieldOrder.indexOf(currentName);
    const previousField = fieldOrder[currentIndex - 1];

    if (previousField) {
      if (modalFields.includes(previousField)) {
        openModalForField(previousField);
      } else {
        const inputField = document.querySelector(
          `input[name="${previousField}"]`
        );
        if (inputField) {
          inputField.focus();
          setOpen(false);
        }
      }
    }
  };
  const itemsCheckedString =
    formData?.ItemsChecked?.map((item) => item.itemName).join(", ") || "";

  const SegmentString =
    formData?.Segment?.map((item) => item.u_Segment).join(", ") || "";

  // Handle Popover
  const handleLeadLevelClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLeadLevelClose = () => {
    setAnchorEl(null);
  };

  const handleLeadLevelSelect = (value) => {
    const updatedFormData = {
      ...formData,
      LeadLevel: value,
    };
    setFormData(updatedFormData);
    dispatch(CRMPostData(updatedFormData));
    handleLeadLevelClose();
  };

  const opens = Boolean(anchorEl);
  const id = opens ? "simple-popover" : undefined;

  const handleDateChange = (newValue) => {
    const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
    const updatedFormData = {
      ...formData,
      ExpectedComplationOfWork: formattedDate,
    };
    setDueDate(newValue)
    setFormData(updatedFormData);
    dispatch(CRMPostData(updatedFormData));
  };
  const prepareDataForSubmission = (formData) => {
    const itemsCheckedData = formData.ItemsChecked.map((item) => ({
      ItemCode: item.itemCode,
      ItemName: item.itemName,
    }));

    const segmentData = formData.Segment.map((segment) => ({
      Segment: segment.u_Segment,
    }));

    const dataToSubmit = [
      {
        WalkINID: formData.WalkINID,
        WalkInType: formData.WalkInType,
        customerCategory: formData.customerCategory,
        CustomerProfile: formData.CustomerProfile,
        PhoneNo: formData.PhoneNo,
        Reference: formData.Reference,
        LeadLevel: formData.LeadLevel,
        SiteType: formData.SiteType,
        CurrentWorkStatus: formData.CurrentWorkStatus,
        ExpectedComplationOfWork: formData.ExpectedComplationOfWork,
        SiteVisit: formData.SiteVist,
        ReqType: formData.RequrimentType,
        AssignExecutive: formData.AssignExecutive,
        Estimated: formData.EstimatedValue,
        ItemsChecked: itemsCheckedData,
        Segments: segmentData,
      },
    ];

    return dataToSubmit;
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const dataToSubmit = prepareDataForSubmission(formData);
    try {
      const response = await PostData(
        `${postCrmData}${databaseName}`,
        dataToSubmit,
        jwtToken,
        dispatch,
        navigate
      );
      if (response === "OK") {
        handleReset();
      }
      setIsLoading(false);
      toast("Request successfully created!", {
        position: "bottom-right",
        theme: "dark",
      });
    } catch (error) {
      setIsLoading(false);
      console.error("Error in handleSubmit:", error);
      toast(error.data, {
        position: "bottom-right",
        theme: "dark",
      });
    }
  };
  const handleReset = () => {
    dispatch(resetCrmData());
  };
  //  const handleModalOpen = (e) => {
  //     const { name, value } = e.target;
  //     if (name === "customerCategory"){
  //       setModalValue(customerCate);
  //       setModalName(name);
  //     }
  //     if (name === "Segment"){
  //       setModalValue(u_Segment);
  //       setModalName(name);
  //     }
  //     if (name === "CustomerProfile"){
  //       setModalValue(u_CustomPro);
  //       setModalName(name);
  //     }
  //     if (name === "SiteType"){
  //       setModalValue(u_SiteType);
  //       setModalName(name);
  //     }
  //     if (name === "CurrentWorkStatus"){
  //       setModalValue(u_CurrentWS);
  //       setModalName(name);
  //     }
  //     setOpen(true)
  //  }
  //  const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   // Update the form data
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });

  //   // Close the current modal
  //   setOpen(false);

  //   // Open the next modal if it exists
  //   openNextModal(name);
  // };

  // const openNextModal = (currentName) => {
  //   const fieldOrder = [
  //     "customerCategory",
  //     "Segment",
  //     "CustomerProfile",
  //     "SiteType",
  //     "CurrentWorkStatus"
  //   ];

  //   const currentIndex = fieldOrder.indexOf(currentName);
  //   const nextField = fieldOrder[currentIndex + 1];

  //   if (nextField) {
  //     if (nextField === "customerCategory"){
  //       setModalValue(customerCate);
  //       setModalName(nextField);
  //     }
  //     if (nextField === "Segment"){
  //       setModalValue(u_Segment);
  //       setModalName(nextField);
  //     }
  //     if (nextField === "CustomerProfile"){
  //       setModalValue(u_CustomPro);
  //       setModalName(nextField);
  //     }
  //     if (nextField === "SiteType"){
  //       setModalValue(u_SiteType);
  //       setModalName(nextField);
  //     }
  //     if (nextField === "CurrentWorkStatus"){
  //       setModalValue(u_CurrentWS);
  //       setModalName(nextField);
  //     }
  //     setOpen(true);
  //   }
  // };

  return (
    <>
      <div className="custom-slider">
        <div className="greeterInput">
          <div className="rightGreeter">
            <div className="greeterInputDiv">
              <label htmlFor="" className="greeterInputLabel">
                Walk-In Id
              </label>
              <input
                id="Walk-INID"
                name="WalkINID"
                variant="standard"
                className="greeterInputText"
                value={formData.WalkINID}
                onChange={handleChange}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="WalkInType "
                label="Walk In Type  "
                name="WalkInType"
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                className="greeterInputText"
                value={formData.WalkInType}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="PhoneNo"
                label="Phone No "
                name="PhoneNo"
                variant="standard"
                className="greeterInputText"
                value={formData.PhoneNo}
                onChange={handleChange}
                 autoComplete="off"
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="Reference"
                label="Reference"
                name="Reference"
                variant="standard"
                className="greeterInputText"
                value={formData.Reference}
                onChange={handleChange}
                 autoComplete="off"
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="LeadLevel"
                label="Lead Level"
                name="LeadLevel"
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                className="greeterInputText"
                value={formData.LeadLevel}
                onClick={handleLeadLevelClick}
                 autoComplete="off"
                readOnly
              />
              <Popover
                id={id}
                open={opens}
                anchorEl={anchorEl}
                onClose={handleLeadLevelClose}
                className="leadLevelpop"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <ul className="leadLevelUl">
                  {["A", "B", "C"].map((level) => (
                    <li
                      key={level}
                      onClick={() => handleLeadLevelSelect(level)}
                    >
                      {level}
                    </li>
                  ))}
                </ul>
              </Popover>
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="AssignExecutive"
                label="Assign Executive"
                name="AssignExecutive"
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                className="greeterInputText"
                value={formData.AssignExecutive}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="customerCategory"
                label="Customer Category"
                name="customerCategory"
                InputProps={{
                  readOnly: true,
                }}
                variant="standard"
                className="greeterInputText"
                value={formData.customerCategory || ""}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="Segment"
                label="Segment"
                name="Segment"
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                className="greeterInputText"
                value={SegmentString || ""}
                onChange={handleSegmentChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="CustomerProfile"
                label="Customer Profile"
                name="CustomerProfile"
                variant="standard"
                className="greeterInputText"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.CustomerProfile || ""}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
          </div>
          <div className="LeftGreeter">
            <div className="greeterInputDiv">
              <TextField
                id="SiteType"
                label="Site Type"
                name="SiteType"
                variant="standard"
                className="greeterInputText"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.SiteType || ""}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="CurrentWorkStatus"
                label="Current Work Status"
                name="CurrentWorkStatus"
                variant="standard"
                className="greeterInputText"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.CurrentWorkStatus || ""}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv ComplationWork">
              {/* <TextField
              id="ExpectedComplationOfWork"
              label="Expected Complation Of Work"
              name="ExpectedComplationOfWork"
              variant="standard"
              className="greeterInputText"
              value={formData.ExpectedComplationOfWork || ""}
              onChange={handleChange}
              // onClick={handleOpen}
            /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Expected Complation Of Work"
                  name="ExpectedComplationOfWork"
                  className="ExpectedCompletion"
                  value={DueDate}
                  minDate={dayjs()}
                  onChange={handleDateChange}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="ItemsChecked"
                label="Items Checked"
                name="ItemsChecked"
                variant="standard"
                className="greeterInputText"
                InputProps={{
                  readOnly: true,
                }}
                value={itemsCheckedString || ""}
                onChange={handleChange}
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="EstimatedValue"
                label="Estimated Value"
                name="EstimatedValue"
                variant="standard"
                className="greeterInputText"
                value={formData.EstimatedValue || ""}
                onChange={handleChange}
                 autoComplete="off"
                // onClick={handleOpen}
              />
            </div>
            <div className="greeterInputDiv">
              <TextField
                id="RequrimentType"
                label="Requriment Type"
                name="RequrimentType"
                variant="standard"
                className="greeterInputText"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.RequrimentType || ""}
                onChange={handleChange}
                
                onClick={(e) => handleModalOpen(e)}
              />
            </div>
            <div className="greeterInputDiv siteVistDiv">
              <div className="siteVistText">
                <p>Site Visit :</p>
              </div>
              <div className="sitevistCheckBox">
                {SiteValues.map((value) => (
                  <div key={value} className="sitevistDiv ">
                    <CustomCheckbox
                      checked={formData.SiteVist === value}
                      onChange={handleSiteChange}
                      value={value}
                      name="SiteVist"
                    />
                    <label className="siteVistLabel" htmlFor="">{value}</label>
                  </div>
                ))}
              </div>
            </div>
            {showAddress && (
              <div className="greeterInputDiv">
                <p>Address</p>
                <textarea
                  name="Address"
                  onChange={handleChange}
                  id=""
                ></textarea>
              </div>
            )}
          </div>
        </div>
        <Commonmodal
          open={open}
          handleClose={handleClose}
          handleChange={handleChange}
          handleSegmentChange={handleSegmentChange}
          formData={formData}
          modalValue={modalValue}
          modalName={modalName}
          handleBack={() => openPreviousModal(modalName)}
          handleForward={() => openNextModal(modalName)}
        />

        <button onClick={handleSubmit} className="CrmButton">
          Submit
        </button>

        <ToastContainer />
        {isLoading && (
          <div className="loader position-absolute ">
            (<SunspotLoader />)
          </div>
        )}
      </div>
    </>
  );
};

export default Greeter;
